var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "search-btn-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.Order"),
                          prop: "orderNo",
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: _vm.$t(
                                "SalesOrderToBeApproved.Tripartite"
                              ),
                              placement: "top",
                            },
                          },
                          [
                            _c("BjInputCode", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "SalesOrderToBeApproved.Order"
                                ),
                                comma: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleQuery.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.queryParams.orderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "orderNo", $$v)
                                },
                                expression: "queryParams.orderNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.SKU"),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("SalesOrderToBeApproved.SKU"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.source"),
                          prop: "actionType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.ORDER_ACTION_TYPE_LIST,
                            placeholder: _vm.$t(
                              "SalesOrderToBeApproved.source"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.actionType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "actionType", $$v)
                            },
                            expression: "queryParams.actionType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channel", "storeIdList"],
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.nickname"),
                          prop: "buyerNick",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "SalesOrderToBeApproved.nickname"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.buyerNick,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "buyerNick", $$v)
                            },
                            expression: "queryParams.buyerNick",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.name"),
                          prop: "receiverName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("SalesOrderToBeApproved.name"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.receiverName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "receiverName", $$v)
                            },
                            expression: "queryParams.receiverName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemMobile", {
                      attrs: {
                        prop: "mobile",
                        label: _vm.$t("SalesOrderToBeApproved.mobile"),
                        placeholder: _vm.$t("SalesOrderToBeApproved.mobile"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.queryParams.mobile,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "mobile", $$v)
                        },
                        expression: "queryParams.mobile",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.Comments"),
                          prop: "buyerRemarks",
                        },
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "option-list": _vm.STATUS_HAVE_TRUE,
                                    placeholder: _vm.$t(
                                      "SalesOrderToBeApproved.Comments"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryParams.isBuyerRemarks,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "isBuyerRemarks",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.isBuyerRemarks",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "text-center",
                                attrs: { span: 1 },
                              },
                              [_vm._v("-")]
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 15 } },
                              [
                                _c("BjInput", {
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    clearable: "",
                                    placeholder: _vm.$t(
                                      "SalesOrderToBeApproved.Comments"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryParams.buyerRemarks,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "buyerRemarks",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.buyerRemarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.Merchant"),
                          prop: "orderRemarks",
                        },
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "option-list": _vm.STATUS_HAVE_TRUE,
                                    placeholder: _vm.$t(
                                      "SalesOrderToBeApproved.Merchant"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryParams.isOrderRemarks,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "isOrderRemarks",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.isOrderRemarks",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "text-center",
                                attrs: { span: 1 },
                              },
                              [_vm._v("-")]
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 15 } },
                              [
                                _c("BjInput", {
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    clearable: "",
                                    placeholder: _vm.$t(
                                      "SalesOrderToBeApproved.Merchant"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryParams.orderRemarks,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "orderRemarks",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.orderRemarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.have"),
                          prop: "isGift",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.STATUS_HAVE_TRUE,
                            placeholder: _vm.$t("SalesOrderToBeApproved.have"),
                          },
                          model: {
                            value: _vm.queryParams.isGift,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "isGift", $$v)
                            },
                            expression: "queryParams.isGift",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.placement"),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "SalesOrderToBeApproved.placement"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime_order,
                            callback: function ($$v) {
                              _vm.queryParamsTime_order = $$v
                            },
                            expression: "queryParamsTime_order",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.Payment"),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "SalesOrderToBeApproved.Payment"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime_pay,
                            callback: function ($$v) {
                              _vm.queryParamsTime_pay = $$v
                            },
                            expression: "queryParamsTime_pay",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.Internal"),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "SalesOrderToBeApproved.Internal"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime_create,
                            callback: function ($$v) {
                              _vm.queryParamsTime_create = $$v
                            },
                            expression: "queryParamsTime_create",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.code"),
                          prop: "address",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.addressList,
                            placeholder: _vm.$t("SalesOrderToBeApproved.code"),
                          },
                          model: {
                            value: _vm.queryParams.address,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "address", $$v)
                            },
                            expression: "queryParams.address",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "beforeSearchBtn",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 24 - _vm.colSpan } },
                  [
                    _c("BjStatusTabs", {
                      attrs: {
                        value: _vm.auditTabsValue,
                        "option-list": _vm.TOW_TABS[_vm.auditType],
                      },
                      on: { handleTabClick: _vm.handleTabClick },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _vm.cptAuditPermission
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onAudit },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SalesOrderToBeApproved.Approved"))
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.cptAuditPermission
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onNoAudit },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SalesOrderToBeApproved.Approval"))
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.deleteCache },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SalesOrderToBeApproved.deleteCache"))
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onOrderRetrieval },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SalesOrderToBeApproved.onOrderRetrieval")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$toBusinessThirdOrderView(
                                                    scope.row.outerOrderNo
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "innerOrderNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$toBusinessOrderInternalView(
                                                    scope.row.innerOrderNo
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "tags"
                                      ? [
                                          _c("BjTagList", {
                                            attrs: {
                                              "tag-code-string":
                                                scope.row[col.prop],
                                              size: "mini",
                                              circle: "",
                                            },
                                          }),
                                        ]
                                      : col.prop === "goodsQuatity"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onSkuDetail(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "totalAmount" ||
                                        col.prop === "buyerPay" ||
                                        col.prop === "costPrice"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$number2money(
                                                  scope.row[col.prop]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "deliveryStatus"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] === 2
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_DELIVER_STATUS_LIST.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "stockFlag"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_NUM.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "isGift"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: scope.row[col.prop]
                                                  ? "success"
                                                  : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.STATUS_HAVE_TRUE.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "actionType"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_ACTION_TYPE_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "businessType"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_BUSINESS_TYPE_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "auditStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_AUDIT_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "preemptionStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_PREEMPT_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "sourceStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_SOURCE_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "suspendStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_HAND_UP_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "syncPreempStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "syncDeliveryStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_STOCK_BACK_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : Object.keys(
                                          _vm.ORDER_DECRYPT_NAME
                                        ).includes(col.prop)
                                      ? [
                                          _c("BjDecrypt", {
                                            attrs: {
                                              row: scope.row,
                                              "row-key": col.prop,
                                              channel: scope.row.channel,
                                              type: _vm.ORDER_DECRYPT_NAME[
                                                col.prop
                                              ],
                                              "order-sn":
                                                scope.row.outerOrderNo,
                                              copy:
                                                col.prop ===
                                                "receiverPhoneMask",
                                            },
                                          }),
                                        ]
                                      : col.prop === "mobile"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("phoneFilter")(
                                                  scope.row[col.prop]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "creationDate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOperateTwoHour")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: {
                                          disabled:
                                            props.row.suspendStatus != "31201",
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onHangUp(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "InternalSalesOrderDetails.Unhook"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.goodsInfoTab.title,
            visible: _vm.goodsInfoTab.visible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.goodsInfoTab, "visible", $event)
            },
          },
        },
        [
          _c("GoodsInfoTab", {
            attrs: {
              "order-id": _vm.goodsInfoTab.orderId,
              "business-type": _vm.ORDER_BUSINESS_TYPES.COMMON,
            },
          }),
        ],
        1
      ),
      _c("formDialog", {
        ref: "failReason",
        on: { comfirm: _vm.getFailReason },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }